import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-policy-inquiry',
  templateUrl: './policy-inquiry.component.html',
  styleUrls: ['./policy-inquiry.component.scss'],
})
export class PolicyInquiryComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  isViewPlan: boolean = false;
  isLoading: boolean = false;
  policyNumber;
  claimID;
  policyData: any;
  currencyCode
  countrycode
  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<PolicyInquiryComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit(): void {
    this.currencyCode=localStorage.getItem('currency');
    this.countrycode=localStorage.getItem('regionSelected');
    this.policyNumber = this.data.itemData.policyNumber;
    this.claimID = this.data.claimID;
    this.getPolicyInquiryData();
  }

  //Get API - Getting Beneficiary List Data.
  async getPolicyInquiryData() {
    this.isLoading = true;
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimID +
        '/policyDetails/' +
        this.policyNumber;

      let response = await this.commonService.commonGet(url);
      this.policyData = response.body;

      this.isLoading = false;
    } catch (err) {
      console.log('Get API Error - Beneficiary List Data', err);
      this.isLoading = true;
    }
  }

  accordionClicked(event) {
    this.isViewPlan = event;
  }

  onClose() {
    this.dialogRef.close();
  }
}
